/* src/app/self-enrollment/information/information.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
#enroll_button {
  width: 180px;
}
.form-control.input-sm {
  font-size: 13px;
}
#dob {
  font-size: 13px;
}
/*# sourceMappingURL=information.component.css.map */
